import React, { useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { Youtube, Image } from 'lucide-react';
export function Media() {
  const {
    ref,
    inView
  } = useInView({
    threshold: 0.1,
    triggerOnce: true
  });
  const [activeTab, setActiveTab] = useState('messages');
  const galleryImages = ["https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/r4ghx198qvioniuadphfqh/81449d38-4222-488a-b12b-9f20b25eda97/photo_2025-11-14_12-43-49.jpg", "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/r4ghx198qvioniuadphfqh/81449d38-4222-488a-b12b-9f20b25eda97/1.jpg", "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/r4ghx198qvioniuadphfqh/81449d38-4222-488a-b12b-9f20b25eda97/photo_2025-11-13_17-38-56.jpg"];
  return <section id="media" className="py-20 bg-gray-50" data-id="element-210">
      <div className="container mx-auto px-4" data-id="element-211">
        <div className="text-center mb-12" data-id="element-212">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-213">
            Media
          </h2>
          <div className="w-24 h-1 bg-pink-600 mx-auto" data-id="element-214"></div>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-215">
            Access our library of messages and photos from past events and
            broadcasts.
          </p>
        </div>

        <div ref={ref} className={`transition-all duration-1000 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-216">
          <div className="flex justify-center mb-8" data-id="element-217">
            <div className="inline-flex bg-white rounded-full shadow-md p-1" data-id="element-218">
              <TabButton active={activeTab === 'messages'} onClick={() => setActiveTab('messages')} icon={<Youtube size={18} data-id="element-220" />} label="Messages" data-id="element-219" />
              <TabButton active={activeTab === 'gallery'} onClick={() => setActiveTab('gallery')} icon={<Image size={18} data-id="element-222" />} label="Gallery" data-id="element-221" />
            </div>
          </div>

          <div className="max-w-5xl mx-auto" data-id="element-223">
            {activeTab === 'messages' && <div className="text-center" data-id="element-224">
                <div className="bg-white rounded-lg shadow-lg p-12" data-id="element-225">
                  <Youtube size={64} className="text-pink-600 mx-auto mb-6" data-id="element-226" />
                  <h3 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-227">
                    Watch Our Messages
                  </h3>
                  <p className="text-gray-600 mb-6" data-id="element-228">
                    Visit our YouTube channel to watch past broadcasts,
                    teachings, and special messages.
                  </p>
                  <a href="https://youtube.com/@shewinsintlministry?si=IFQ2JNaBdLNMRnNI" target="_blank" rel="noopener noreferrer" className="bg-pink-600 hover:bg-pink-700 text-white font-medium py-3 px-8 rounded-full inline-flex items-center transition-colors duration-200" data-id="element-229">
                    <Youtube size={20} className="mr-2" data-id="element-230" />
                    Visit YouTube Channel
                  </a>
                </div>
              </div>}

            {activeTab === 'gallery' && <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-231">
                {galleryImages.map((image, index) => <div key={index} className="aspect-square overflow-hidden rounded-lg" data-id="element-232">
                    <img src={image} alt={`Gallery image ${index + 1}`} className="w-full h-full object-cover transition-transform duration-300 hover:scale-105" data-id="element-233" />
                  </div>)}
              </div>}
          </div>
        </div>
      </div>
    </section>;
}
function TabButton({
  active,
  onClick,
  icon,
  label
}) {
  return <button className={`flex items-center py-2 px-6 rounded-full transition-colors duration-200 ${active ? 'bg-pink-600 text-white' : 'bg-transparent text-gray-600 hover:text-pink-600'}`} onClick={onClick} data-id="element-234">
      <span className="mr-2" data-id="element-235">{icon}</span>
      <span data-id="element-236">{label}</span>
    </button>;
}